<template>
  <v-modal
    :name="name"
    title="Solicitar ajuda da Vibbra"
    :show="show"
    @onHide="onHide"
    @onShow="onShow"
    :size="1"
  >
    <v-inner>
      <div v-if="!help_ok">
        <v-text
          >Informe abaixo com o que você precisa de ajuda e uma breve descrição,
          que logo a nossa equipe entrará em contato com você.</v-text
        >
        <v-input
          type="select"
          v-model="question.subject"
          :disabled="disabled"
          :options="subjects"
          option_label_list="name"
          >Assunto</v-input
        >
        <v-input type="textarea" v-model="question.body" rows="5"
          >Mensagem</v-input
        >
        <v-button class="block primary" @click="sendHelpMessage()"
          >Enviar</v-button
        >
      </div>
      <div v-else>
        <v-text class="p-3"
          >Recebemos a sua solicitação e em breve faremos contato.</v-text
        >
        <v-button class="block primary" @click="hide()">Fechar</v-button>
      </div>
    </v-inner>
  </v-modal>
</template>

<script>
import clientApi from '@/api/client';
import vibbranteApi from '@/api/vibbrante';

export default {
  props: {
    show: {
      default: false,
    },
    title: {
      default: '',
    },
    name: {
      default: 'modal',
    },
    size: {
      default: 3,
    },
    profile: {
      default: 'client',
    },
    data: {},
    subjectId: {
      default: 0,
    },
  },
  data() {
    return {
      help_ok: false,
      subjects: [],
      disabled: false,
      question: {
        subject: {},
        body: '',
      },
    };
  },
  methods: {
    hide() {
      this.onHide();
      this.show = false;
    },
    onHide() {
      this.refresh = false;
      this.$emit('onHide');

      // OK vars
      this.feedback_ok = false;
      this.bug_ok = false;
      this.money_transfer_ok = false;
      this.help_ok = false;
      this.finalized_ok = false;
    },
    onShow() {
      this.question = {
        subject: {},
        body: '',
      };
      if (this.profile === 'client') {
        clientApi
          .clientLoadSubjects()
          .then(response => {
            if (response.status === 200) {
              this.subjects = response.data;
              if (this.data.option) {
                for (let index = 0; index < this.subjects.length; index++) {
                  if (this.subjects[index].name === this.data.option) {
                    this.disabled = true;
                    this.question = {
                      subject: {
                        id: this.subjects[index].id,
                        name: this.subjects[index].name,
                      },
                      body: '',
                    };
                  }
                }
              }
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
      } else {
        vibbranteApi
          .vibbranteLoadSubjects()
          .then(response => {
            if (response.status === 200) {
              this.subjects = response.data;
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
      }
    },
    sendHelpMessage() {
      if (this.profile === 'client') {
        let body = this.question.body;
        if (this.data.contract_id !== undefined) {
          body = body + ' -- Contrato: ' + this.data.contract_id;
        }

        clientApi
          .clientCreateHelpMessage(this.question.subject.id, body)
          .then(response => {
            if (response.status === 200) {
              this.help_ok = true;
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
      } else {
        vibbranteApi
          .vibbranteCreateHelpMessage(
            this.question.subject.id,
            this.question.body
          )
          .then(response => {
            if (response.status === 200) {
              this.help_ok = true;
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/parts/modals/help.vue